var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDraftsSelected(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 20.5H6C5.44772 20.5 5 20.0523 5 19.5V4.5C5 3.94772 5.44771 3.5 6 3.5H14.3333L19 8.22222V19.5C19 20.0523 18.5523 20.5 18 20.5Z",
    fill: "url(#paint0_linear_3331_15870)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 8.22222H19.5C19.5 8.09064 19.4481 7.96436 19.3556 7.87077L19 8.22222ZM14.3333 3.5L14.689 3.14854C14.595 3.05349 14.467 3 14.3333 3V3.5ZM14.3333 8.22222H13.8333V8.72222H14.3333V8.22222ZM6 20.5V21H18V20.5V20H6V20.5ZM19 19.5H19.5V8.22222H19H18.5V19.5H19ZM19 8.22222L19.3556 7.87077L14.689 3.14854L14.3333 3.5L13.9777 3.85146L18.6444 8.57368L19 8.22222ZM14.3333 3.5V3H6V3.5V4H14.3333V3.5ZM5 4.5H4.5V19.5H5H5.5V4.5H5ZM14.3333 3.5H13.8333V8.22222H14.3333H14.8333V3.5H14.3333ZM14.3333 8.22222V8.72222H19V8.22222V7.72222H14.3333V8.22222ZM6 3.5V3C5.17157 3 4.5 3.67157 4.5 4.5H5H5.5C5.5 4.22386 5.72386 4 6 4V3.5ZM18 20.5V21C18.8284 21 19.5 20.3284 19.5 19.5H19H18.5C18.5 19.7761 18.2761 20 18 20V20.5ZM6 20.5V20C5.72386 20 5.5 19.7761 5.5 19.5H5H4.5C4.5 20.3284 5.17157 21 6 21V20.5Z",
    fill: "url(#paint1_linear_3331_15870)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3331_15870",
    x1: 12,
    y1: 3.1792,
    x2: 11.54,
    y2: 20.9911,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1851B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#99AFD3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3331_15870",
    x1: 12,
    y1: 3.5,
    x2: 12,
    y2: 20.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E3C81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95ACD2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDraftsSelected);
export default __webpack_public_path__ + "static/media/draftsSelected.2d998fff177d3880478dd789d89fbb5d.svg";
export { ForwardRef as ReactComponent };